import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "lc_btn_cancel_icon",
  "use": "lc_btn_cancel_icon-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"lc_btn_cancel_icon\"><defs><style type=\"text/css\"></style></defs><path d=\"M806.4 334.924H314.444v-209.05L0 369.74 314.444 598.4V411.723H806.4c81.587 0 140.8 59.214 140.8 140.8v128c0 42.343-11.213 140.8-115.2 140.8H140.8v76.8H832c116.634 0 192-85.401 192-217.6v-128c0-124.057-93.542-217.6-217.6-217.6z\" p-id=\"5260\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol